/** @flow */

export const isLoading = (state: Object) => {
  return state.reporting.dataForecasts.requestsInProgress !== 0;
};

export const getDataForecasts = (state: Object) => {
  return state.reporting.dataForecasts.data;
};
